import api from "./axios";

export const getTechStack = () => api.get("/api/tech-stack/");

// Admin
export const adminGetTechStack = () => api.get("/api/admin/tech-stack/");
export const adminCreateTechStackItem = (data) => api.post("/api/admin/tech-stack/", data);

export const adminGetTechStackItem    = (id)       => api.get(`/api/admin/tech-stack/${id}/`);
export const adminUpdateTechStackItem = (id, data) => api.put(`/api/admin/tech-stack/${id}/`, data);
export const adminDeleteTechStackItem = (id)       => api.delete(`/api/admin/tech-stack/${id}/`);